export const ADMIN_SETTINGS_USERS_WHITELIST = [
  "alexei.moltchan@verve.com",
  "ieva.balode@verve.com",
  "paul@dataseat.com",
  "juan@dataseat.com",
  "olha@dataseat.com",
  "eduardo@dataseat.com",
];
